import assign from 'lodash/assign';
import type { AllActionTypes } from '../constants';
import constants from '../constants';
import type Comparables from '../../models/Comparables';

export interface State {
  min: number | null;
  max: number | null;
  items: Array<Comparables>;
  userPropertyIdx: number | null;
}

export type Actions = { type: AllActionTypes; payload: State };

const initialState: State = {
  min: null,
  max: null,
  items: [],
  userPropertyIdx: null,
};

const comparables = (state: State = initialState, action: Actions): State => {
  const { type, payload } = action;

  if (type === constants.SET_COMPARABLES) {
    return assign({}, payload);
  }
  return state;
};

export default comparables;
